module.exports = __webpack_public_path__ + "assets/img/m21.69b24534.png";